export class VideoPlayer {
    video: anm.VideoPlayerData;
    showVideo: boolean;
    showPreview                       = true;
    settings: anm.VideoPlayerSettings = this.settings || {};

    private videoEl: HTMLVideoElement;
    private videoHandlerBind = angular.noop;
    private defaultSetting   = {
        preload: true,
        muted: true,
        loop: true,
        controls: false
    };

    constructor(private $element: ng.IAugmentedJQuery,
                private $rootScope: ng.IRootScopeService) {
        this.videoHandlerBind = () => this.videoHandler();
        if (!this.video.preview) this.loadVideo();
    }

    $onDestroy() {
        this.videoEl && this.videoEl.removeEventListener('loadeddata', this.videoHandlerBind);
    }

    videoHandler() {
        this.showPreview = false;
        this.$rootScope.$apply();
        this.setVideoSettings();
    }

    loadVideo() {
        this.showVideo = true;

        setTimeout(() => {
            this.videoEl = this.$element[0].querySelector('video');
            this.videoEl.addEventListener('loadeddata', this.videoHandlerBind);
        }, 0);
    }

    triggerPlay() {
        this.videoEl = this.$element[0].querySelector('video');
        this.videoEl && this.videoEl.paused ? this.videoEl.play() : this.videoEl.pause();
    }

    private setVideoSettings() {
        Object.assign(
            this.videoEl,
            this.defaultSetting,
            this.settings
        )
    }
}

angular.module('animatronApp.videoPlayer', []).component('videoPlayer', {
    bindings: {
        video: '<',
        settings: '<'
    },
    controller: VideoPlayer,
    templateUrl: require('video-player.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/videoPlayer.ts